import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { IChatForm } from '@nimbus-global/features/chat-form/models/chat-form.model';
import { IChatFormFieldValidation } from '@nimbus-global/features/chat-form/models/chat-form-resolver.model';
import { CompanionReferenceType } from '@nimbus-library/features/companion-chat/models/companion-conversation.model';
import { IChatFormEntityHandler } from '@nimbus-library/features/companion-chat/services/form-entity-handlers/i-chat-form-entity-handler';
import { IOptionItem } from '@nimbus-library/features/shared/models/interfaces/i-option-item';
import { OperationsServicesLookupService } from '@nimbus-admin/features/operations/services/operations-services-lookup.service';
import { GroupSelectionLookupService } from '@nimbus-admin/features/organization-unit/services/group-selection-lookup.service';

const now = (): Date => new Date();

@Injectable({ providedIn: 'root' })
export class TeamChatFormEntityHandler implements IChatFormEntityHandler {
  public readonly entity = CompanionReferenceType.Team;

  public constructor(
    private readonly lookupService: OperationsServicesLookupService,
    private readonly groupSelectionLookupService: GroupSelectionLookupService,
  ) {}

  public resolveReferenceOptions(
    referenceType: string,
    _form: IChatForm,
    currentValues?: Record<string, unknown>,
  ): Observable<IOptionItem[]> {
    const tenantId = currentValues?.tenantId as string;
    switch (referenceType) {
      case CompanionReferenceType.Tenant: {
        return this.groupSelectionLookupService.getTenantOptions(tenantId);
      }
      case CompanionReferenceType.Team: {
        return tenantId ? this.lookupService.fetchServices(tenantId) : of([]);
      }
      default:
        return of([]);
    }
  }

  public resolveFieldTitle(field: string): TranslationKeys {
    switch (field) {
      case 'teamId':
        return TranslationKeys.GeneralService;
      case 'tenantId':
        return TranslationKeys.AdminCommonTenant;
      case 'fromUtc':
        return TranslationKeys.GeneralFrom;
      case 'toUtc':
        return TranslationKeys.GeneralTo;
      case 'atUtc':
        return TranslationKeys.GeneralAt;
      default:
        return TranslationKeys.GeneralName;
    }
  }

  public resolveFieldValidation(field: string): IChatFormFieldValidation | null {
    switch (field) {
      case 'fromUtc':
      case 'toUtc':
        return { maxDate: now };
      default:
        return null;
    }
  }
}
